import { SelectOptionType } from '@/app/types/constantDataType'
import CheckIcon from '@mui/icons-material/Check'
import { components, OptionProps } from 'react-select'

/**
 * Custom option component for react-select with a trailing check icon.
 *
 * @param {OptionProps<SelectOptionType, true>} props - The props for the custom option.
 * @returns {JSX.Element} The rendered custom option.
 */
export const CustomCheckIconOption = (
  props: OptionProps<SelectOptionType, true>
) => {
  const { isSelected, data } = props
  const passByValueIsSelected = isSelected || data?.other?.allSelectSelected
  const isSelectAllOption =
    data?.label == 'UnSelect All' || data?.label == 'Select All'

  return (
    <components.Option
      {...props}
      className="!p-2 !bg-base !flex !flex-row items-center !cursor-pointer justify-between"
    >
      <p className={passByValueIsSelected ? 'text-active' : ''}>
        {data?.label}
      </p>
      {passByValueIsSelected && !isSelectAllOption && (
        <CheckIcon className=" !text-[orange]" />
      )}
    </components.Option>
  )
}
